import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Video = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="m16.211 11.106.224-.447zM9.737 7.868l-.224.447zM8 8.942h.5zm0 6.116h.5zm1.737 1.074-.224-.447zm6.474-3.238.224.447zm0-1.788.224-.447L9.96 7.42l-.224.447-.224.447 6.474 3.238zM9.737 7.868l.224-.447a1.7 1.7 0 0 0-.837-.178l.022.5.023.499a.7.7 0 0 1 .344.073zm-.59-.126-.023-.5a1.7 1.7 0 0 0-.818.253l.263.425.263.426a.7.7 0 0 1 .337-.104zm-.578.178-.263-.425a1.7 1.7 0 0 0-.591.619l.437.243.436.244a.7.7 0 0 1 .244-.255zm-.417.437-.437-.243a1.7 1.7 0 0 0-.215.828h1a.7.7 0 0 1 .088-.341zM8 8.942h-.5v6.116h1V8.942zm0 6.116h-.5c0 .29.074.575.215.828l.437-.243.436-.244a.7.7 0 0 1-.088-.34zm.152.585-.437.243a1.7 1.7 0 0 0 .591.619l.263-.425.263-.426a.7.7 0 0 1-.244-.255zm.417.436-.263.426a1.7 1.7 0 0 0 .818.252l.022-.5.023-.499a.7.7 0 0 1-.337-.104zm.577.179-.022.5c.29.012.577-.05.837-.179l-.224-.447-.224-.447a.7.7 0 0 1-.344.073zm.591-.126.224.447 6.474-3.238-.224-.447-.224-.447-6.474 3.238zm6.474-3.238.224.447a1.5 1.5 0 0 0 .604-.553l-.425-.263-.426-.262a.5.5 0 0 1-.201.184zm.403-.369.425.263a1.5 1.5 0 0 0 .224-.788h-1a.5.5 0 0 1-.075.263zm.149-.525h.5a1.5 1.5 0 0 0-.224-.788l-.425.263-.426.262a.5.5 0 0 1 .075.263zm-.15-.525.426-.263a1.5 1.5 0 0 0-.604-.553l-.224.447-.224.447a.5.5 0 0 1 .201.184zM21 12h-.5a8.5 8.5 0 0 1-8.5 8.5v1a9.5 9.5 0 0 0 9.5-9.5zm-9 9v-.5A8.5 8.5 0 0 1 3.5 12h-1a9.5 9.5 0 0 0 9.5 9.5zm-9-9h.5A8.5 8.5 0 0 1 12 3.5v-1A9.5 9.5 0 0 0 2.5 12zm9-9v.5a8.5 8.5 0 0 1 8.5 8.5h1A9.5 9.5 0 0 0 12 2.5z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Video) as SvgIcon;
export { ForwardRef as ReactComponent };
